export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";
export const USER_CRM_SUCCESS = "USER_CRM_SUCCESS";
export const USER_CRM_REQUEST = "USER_CRM_REQUEST";
export const USER_CRM_ERROR = "USER_CRM_ERROR";
export const USER_SET_ACCESS_TOKEN = "USER_SET_ACCESS_TOKEN";
